import { queries as jobDetailsQueries } from "domains/hire/containers/JobDetails/queries";
import type { WarmableQuery } from "routing/warmQueries";

export const queries = (input: Parameters<typeof jobDetailsQueries>[0]): Array<WarmableQuery> =>
  jobDetailsQueries(input);
